(function() {
    'use strict';

    angular
        .module('core')
        .filter('insuranceBandFilter', function() {
            return function(bands, guest) {
                let filteredBands = [];
                if (guest.Type === 1) {
                    angular.forEach(bands, function(band) {
                        if (guest.Type === band.PassengerType) {
                            filteredBands.push(band);
                        }
                    });
                } else {
                    angular.forEach(bands, function(band) {
                        if (guest.Age <= band.EndAge && guest.Age >= band.StartAge) {
                            filteredBands.push(band);
                        }
                    });
                }
                return filteredBands;
            };
        });
})();
